export default __webpack_public_path__ + "static/media/card9.1d7a1848.png";